export default __webpack_public_path__ + "static/alec-bitmoji-30db76b4401053cd4f16b1e6ab5d7765.png";